export default function user(state = {}, action = {}) {
    switch (action.type) {
        case 'GET_CONFIG_RESULT':
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/config.js